import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {RtPlatformService} from '../../rt-platform/rt-platform.service';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RtElementResizedDirective } from '../../rt-element-resized/rt-element-resized.directive';

@Component({
    selector: 'rt-loading',
    templateUrl: './rt-loading.component.html',
    styleUrls: ['./rt-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('halfDisappear', [
            state('true', style({ opacity: 0.6 })),
            state('false', style({ opacity: 1 })),
            transition('false => true', [animate(300)]),
            transition('true => false', [animate(200)]),
        ]),
    ],
    imports: [NgClass, MatProgressBar, NgStyle, MatProgressSpinner, NgTemplateOutlet, RtElementResizedDirective]
})
export class RtLoadingComponent implements OnChanges, AfterViewInit {
  @Input() strategy: 'replace' | 'overlay' | 'disappear' = 'replace';
  @Input() type: 'circular' | 'linear' = 'circular';
  @Input() until = true;
  @Input() while = false;
  @Input() circularHeight = 60;
  @Input() linearHeight = 3;
  @Input() overlayColor = '#ffffff';
  @Input() centringCircular = true;
  @Input() isFixed = false;

  @ViewChild('content') content: ElementRef;

  public contentHeight: number;
  public contentWidth: number;

  public showLoading = !this.until && this.while;

  constructor(protected platform: RtPlatformService) {}

  public ngAfterViewInit(): void {
    this.calculateContentSizes();
  }

  public ngOnChanges(): void {
    this.showLoading = !this.until || this.while;
  }

  public calculateContentSizes(): void {
    if (this.platform.isBrowser) {
      const rect = this.content.nativeElement.getBoundingClientRect();
      this.contentHeight = rect.height;
      this.contentWidth = rect.width;
    }
  }
}
